<h3 class="text--large text--thin">{{ heading }}
  @if (infoText) {
    <info-badge>{{ infoText }}</info-badge>
  }
</h3>

<div class="flex__container margin-top--2x">
  <div
    class="display--block margin-right--6x"
 
  >
    <canvas
      baseChart
      width="200" height="200"
      [legend]="false"
      [type]="'doughnut'"
      [data]="chartData"
      [options]="chartOptions"
      [labels]="chartLabels">
    </canvas>
  </div>

  <table>
    <tbody>
      @for(label of chartLabels; track $index; let index = $index;) {
        <tr>
          <td class="text--semi-strong padding-right--3x padding-bottom--2x">
            <span
              class="color-box margin-right--1x"
              [ngStyle]="{ 'background-color': colors[index] }"
            ></span>
            {{ label }}
          </td>
          <td class="padding-bottom--2x text--thin">
            {{ distributionData[index] | number }} {{ viewCurrency }} ({{
              totalDataShare(distributionData[index]) | percent: PERCENT_FORMAT
            }})
          </td>
        </tr>
      }
    </tbody>
  </table>

</div>
